<div
  #modalContents
  [class]="getClassLinked()"
  aria-modal="true"
  role="dialog"
  aria-labelledby="linked-reservation-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head05">
      <h1 id="linked-reservation-modal-title" class="p-modal-head05__title">
        <span [innerHTML]="'label.linkedReservation' | staticMsg"></span>
      </h1>
      <button id="linked-reservation-modal-h2" class="p-modal-head05__close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <ng-container *ngIf="!isEmpty; else linkedOrdersNotExist">
      <div class="p-modal-menu01">
        <ul class="p-modal-menu01__list">
          <ng-container *ngFor="let item of this.linkedOrders">
            <li class="p-modal-menu01__list-item">
              <div class="p-modal-menu01__list-btn" (click)="refreshData(item)">
                <span class="p-modal-menu01__list-btn-label--em">{{ item.orderId }}</span>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <!-- 1.3 関連PNRなし -->
    <ng-template #linkedOrdersNotExist>
      <div class="p-modal-body06">
        <div class="p-modal-menu01">
          <div class="p-modal-menu01__note">
            <div class="p-modal-menu01__note-item">
              <div
                class="p-modal-menu01__note-title p-modal-menu01__note-title--em"
                [innerHTML]="'label.noLinkedReservationsCaption' | staticMsg"
              ></div>
              <div class="p-modal-menu01__note-contents">
                <p [innerHTML]="'label.noLinkedReservationsText' | staticMsg"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="p-modal-menu01__item p-modal-menu01__add">
      <button
        class="p-modal-menu01__add-btn"
        (click)="onAddReservation()"
        id="linked-reservation-modal-footer-button"
        attr.aria-label="{{ 'alt.pnrAddModalDisplay' | staticMsg }}"
      >
        <span class="p-modal-menu01__add-btn-label" [innerHTML]="'label.addReservation' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
